import { brandSchema, marketSchema } from 'data/schema';
import type { IBrand, IMarket } from 'data/schema';

export interface IParsedDealerId {
  market: IMarket;
  brand: IBrand;
}

const VALID_MARKETS = new Set<string>(marketSchema.options.filter((market) => market !== '*'));
const VALID_BRANDS = new Set<string>(brandSchema.options.filter((brand) => brand !== '*'));
// [A-Z0-9] only, with at most one '-' separator — IDs reach TVM URL paths and the X-Dealer header.
const DEALER_ID_CHARSET_PATTERN = /^[A-Z0-9]+(?:-[A-Z0-9]+)?$/;

/** Parses a Dealer ID into its market/brand, or null when the ID is malformed. Never alters the input. */
export function parseDealerId(dealerId: string): IParsedDealerId | null {
  if (!DEALER_ID_CHARSET_PATTERN.test(dealerId)) return null;

  const dashIndex = dealerId.lastIndexOf('-');
  const segment = dashIndex === -1 ? dealerId : dealerId.slice(dashIndex + 1);
  if (segment.length < 4) return null;

  const market = segment.slice(0, 3);
  const brand = segment.slice(-1);
  if (!VALID_MARKETS.has(market) || !VALID_BRANDS.has(brand)) return null;

  return { market: market as IMarket, brand: brand as IBrand };
}

export function isDealerIdFormatValid(dealerId: string): boolean {
  return parseDealerId(dealerId) !== null;
}
